import {CodeIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'

import {isFeatureEnabled} from '@github-ui/feature-flags'

import type {Server} from '../../types'

export const getMcpRegistryHostPort = () => {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    return 'localhost:8080'
  }

  return 'api.mcp.github.com'
}

const getRegistryServerUrl = (id: string) => {
  return `${getMcpRegistryHostPort()}/v0/servers/${id}`
}

type Props = {
  mcp: Server
  muted?: boolean
}

export function InstallButton({mcp, muted}: Props) {
  const isMcpRegistryDevEnabled = isFeatureEnabled('mcp_registry_dev')

  const getEncodedBasicInfo = () => {
    return encodeURIComponent(
      JSON.stringify({
        name: mcp.name,
        type: 'http',
        url: mcp.url,
      }),
    )
  }

  const handleInstallWithProtocol = (protocol: string) => {
    const url = `${protocol}:mcp/${getRegistryServerUrl(mcp.id)}`
    window.open(url, '_self')
  }

  const handleInstallInVSCode = () => handleInstallWithProtocol('vscode')
  const handleInstallInVSCodeInsiders = () => handleInstallWithProtocol('vscode-insiders')
  const handleInstallInVSCodeOSS = () => handleInstallWithProtocol('code-oss')

  const handleInstallInVisualStudio = () => {
    const encodedData = getEncodedBasicInfo()
    window.open(`vsweb+mcp:/install?${encodedData}`, '_self')
  }

  return (
    <ActionMenu>
      <ActionMenu.Button variant={muted ? 'default' : 'primary'} block={!muted} size={muted ? 'small' : 'large'}>
        {muted ? 'Install' : 'Install MCP server'}
      </ActionMenu.Button>

      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.Item onSelect={handleInstallInVSCode}>
            <ActionList.LeadingVisual>
              <CodeIcon size={16} />
            </ActionList.LeadingVisual>
            Install in VS Code
          </ActionList.Item>

          <ActionList.Item onSelect={handleInstallInVSCodeInsiders}>
            <ActionList.LeadingVisual>
              <CodeIcon size={16} />
            </ActionList.LeadingVisual>
            Install in VS Code Insiders
          </ActionList.Item>

          {isMcpRegistryDevEnabled && (
            <ActionList.Item onSelect={handleInstallInVSCodeOSS}>
              <ActionList.LeadingVisual>
                <CodeIcon size={16} />
              </ActionList.LeadingVisual>
              Install in VS Code Development Environment
            </ActionList.Item>
          )}

          {isMcpRegistryDevEnabled && (
            <ActionList.Item onSelect={handleInstallInVisualStudio}>
              <ActionList.LeadingVisual>
                <CodeIcon size={16} />
              </ActionList.LeadingVisual>
              Install in Visual Studio
            </ActionList.Item>
          )}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ InstallButton.displayName ||= 'InstallButton' } catch {}